import { render, staticRenderFns } from "./ThematicList.vue?vue&type=template&id=eda5256a&scoped=true&"
import script from "./ThematicList.vue?vue&type=script&lang=js&"
export * from "./ThematicList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda5256a",
  null
  
)

export default component.exports